
































import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, MUTATIONS_TOASTS } from '@/enums'
import { mdiClose, mdiInformation, mdiAlertOctagon } from '@mdi/js'
import { IToastType, IStateToasts } from '@/models'

const { mapState, mapMutations } = createNamespacedHelpers(STORE_MODULES.TOASTS)

export default Vue.extend({
    name: 'TheToasts',

    data: () => ({ mdiClose }),

    computed: {
        ...(mapState(['toasts']) as MapStateToComputed<IStateToasts>),
    },

    methods: {
        ...mapMutations({
            removeToast: MUTATIONS_TOASTS.REMOVE_TOAST,
        }),

        getIcon(toastType: IToastType): string {
            switch (toastType) {
                case 'error':
                    return mdiAlertOctagon
                default:
                    return mdiInformation
            }
        },
    },
})
